import { LangueEnum } from '../constantes/langue.enum';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { LangueService } from '@services/langue/langue.service';
import { TelephoneMouvement } from '../api/model/telephone-mouvement.model';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'phone',
  standalone: false,
})
export class PhonePipe implements PipeTransform {
  private readonly maskFr: string = '$1 $2-$3';
  private readonly maskEn: string = '$1-$2-$3';
  private readonly regSpaceDash: RegExp = /(-)|( )*/g;
  private readonly regNumberByGroup: RegExp = /^(\d{0,3})(\d{0,3})(\d{0,4})/;
  private readonly posteFr: string = ', poste ';
  private readonly posteEn: string = ', ext. ';

  private readonly langueService = inject(LangueService);
  readonly translateService = inject(TranslateService);
  constructor() {}

  transform(tel: TelephoneMouvement): string {
    let numero = '';
    let poste = '';
    const isFrancais = this.langueService.getCurrentLanguage() === LangueEnum.FR;

    if (tel) {
      numero = tel.numeroTelephone ?? '';
      poste = tel.numeroPoste ?? '';
    }

    if (!numero) {
      return '';
    }

    numero = numero.replace(this.regSpaceDash, '');
    let formatted = numero.replace(this.regNumberByGroup, isFrancais ? this.maskFr : this.maskEn);
    formatted = formatted.trim().replace(/[\s-]+$/, '');

    if (poste) {
      formatted += isFrancais ? this.posteFr + poste : this.posteEn + poste;
    }
    if (tel.typeAppareil) {
      let typeAppareil = this.translateService.instant(
        `donneeReference.typeAppareil.${tel.typeAppareil.toLowerCase()}`,
      );
      formatted += typeAppareil ? `\n${typeAppareil}` : '';
    }
    return formatted;
  }
}
